import React, { useEffect, useState } from 'react'

import Carousel from 'react-multi-carousel'
import { items } from './items'

import { useWindowSize } from 'shared/hooks'

import 'react-multi-carousel/lib/styles.css'
import carouselClasses from 'styles/carousel.module.scss'
import classes from './Slider.module.scss'

const sliderSettings = (showDots: boolean) => ({
  arrows: false,
  autoPlay: true,
  centerMode: true,
  className: `${classes.slider} reveal-from-bottom-medium`,
  draggable: true,
  focusOnSelect: false,
  infinite: true,
  itemClass: classes.slider_item,
  keyBoardControl: false,
  minimumTouchDrag: 80,
  renderButtonGroupOutside: false,
  renderDotsOutside: true,
  showDots: showDots,
  dotListClass: carouselClasses.dotList,
  swipeable: true,
  responsive: {
    desktop: {
      breakpoint: { max: 3000, min: 719 },
      items: 4,
    },
    mobile: {
      breakpoint: { max: 719, min: 0 },
      items: 1,
    },
  },
})

export const Slider = (): JSX.Element => {
  const { isDesktop, width } = useWindowSize()
  const [sliderConfig, setSliderConfig] = useState(sliderSettings(!isDesktop))

  useEffect(() => {
    setSliderConfig(sliderSettings(width < 719))
  }, [width])
  return (
    <div className={classes.slider_wrap}>
      <Carousel data-reveal-delay={30} {...sliderConfig}>
        {items.map((item, itemIndex) => (
          <div key={itemIndex} className={classes.img_wrap}>
            <img src={item.src} alt={item.alt} />
          </div>
        ))}
      </Carousel>
    </div>
  )
}
